import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  input,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Button } from '../../../models/wl_components/button.interface';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'wl-button',
  imports: [CommonModule, MatIconModule, MatButtonModule, MatTooltipModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ButtonComponent {
  disabled = input<boolean>(false);
  @Input() config: Button = { text: 'Click me' };
  @Output() buttonClick = new EventEmitter();
}
